// Transform block tree state functions to block server api
const BlockActionFunctionTransformer = (origin) => {

    const data = { ...origin };

    data.functions = (data.functions || []).map((fn) => ({
        index: fn.index,
        variable_id: fn.variable ? fn.variable.id : null,
        functions: fn.value ?? fn.call_name ?? fn.function ?? '',
        parameters: (fn.params ?? fn.parameters ?? []).map((p) => {
            const val = p.value ?? '';
            if (val !== '' && !isNaN(val) && String(val).trim() !== '') return { ...p, value: Number(val) };
            return p;
        }),
    }));

    return data
}

export default BlockActionFunctionTransformer;
